"use client";

import React from "react";
import styles from "./TodoCard.module.scss";
import { getIssuesMap } from "~/cores/appCore";
import { TurnrCard } from "~/components/card/TurnrCard.jsx";
import OpenCloseChevronIcon from "~/components/icons/OpenCloseChevronIcon.jsx";
import classNames from "classnames";
import TurnrLink from "~/components/links/TurnrLink";
import { serviceIsLoading } from "rylak-common";

function TodoAlert({ amount, title, href, type }) {
    return (
        <TurnrLink href={href} noStyling>
            <div className={classNames(styles["todo-alert"], styles["todo-alert-" + type])}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div className={styles["todo-alert-circle"]} />
                    <span className={styles["todo-alert-amount"]}>
                        {amount} {title}
                    </span>
                </div>
                <div className={styles["todo-alert-chevron"]}>
                    <OpenCloseChevronIcon />
                </div>
            </div>
        </TurnrLink>
    );
}

export default function TodoCard({ appProps, loading }) {
    const todoInfo = Object.values(getIssuesMap(appProps)).filter((t) => t?.amount);

    const loadingHeightForActionsAndErrors = "180px";

    return (
        <>
            {todoInfo?.length > 0 && (
                <TurnrCard className={styles["todo-alert-wrapper"]} loadingMinHeight={loadingHeightForActionsAndErrors} loading={loading || serviceIsLoading(appProps?.actionSummaryServiceData)}>
                    {todoInfo?.map((t) => {
                        return <TodoAlert key={t.title || t.href} {...t} />;
                    })}
                </TurnrCard>
            )}
        </>
    );
}
